import URI from "urijs";

export class URL extends URI {
  constructor() {
    super();
    const newUrl = new URI();
    return newUrl.relativeTo(newUrl.origin());
  }
}
